<div class="actions-container"><button mat-raised-button class="new-button" (click)="addNewEmployee()">New Employee</button>
</div>
